import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { signOutUser } from '../firebase/auth';
import { doc, onSnapshot } from 'firebase/firestore';
import { db } from '../firebase/firestore';
import { applyTheme } from '../utils/themes';
import { displayName } from '../utils/displayName';
import PhotoGallery from '../components/PhotoGallery';
import ExploreMap from '../components/ExploreMap';
import TripTimeline from '../components/TripTimeline';
import Blog from '../components/Blog';
import BmiTracker from '../components/BmiTracker';
import Budget from '../components/Budget';
import Settings from '../components/Settings';
import './Home.scss';

const TABS = [
  { id: 'gallery',  label: 'Gallery',     icon: '🖼'  },
  { id: 'map',      label: 'Explore Map', icon: '🌍'  },
  { id: 'timeline', label: 'Trips',       icon: '✈️'  },
  { id: 'blog',     label: 'Blog',        icon: '💌'  },
  { id: 'health',   label: 'Health',      icon: '⚖️'  },
  { id: 'budget',   label: 'Budget',      icon: '💰'  },
];

const Home = () => {
  const { user } = useAuth();
  const [activeTab, setActiveTab] = useState('gallery');
  const [menuOpen, setMenuOpen] = useState(false);
  const [showSettings, setShowSettings] = useState(false);

  useEffect(() => {
    const unsub = onSnapshot(doc(db, 'health', 'profiles'), snap => {
      if (snap.exists()) {
        const t = snap.data()[user.email]?.theme;
        if (t) applyTheme(t);
      }
    });
    return unsub;
  }, [user.email]);

  const selectTab = (id) => {
    setActiveTab(id);
    setMenuOpen(false);
  };

  return (
    <div className="home">
      <header className="home-header">
        <Link to="/" className="header-brand">
          <span className="header-heart">♥</span>
          <span className="header-names">RK & Indu</span>
        </Link>

        {/* Desktop tabs */}
        <nav className="header-tabs">
          {TABS.map(tab => (
            <button
              key={tab.id}
              className={`tab-btn ${activeTab === tab.id ? 'active' : ''}`}
              onClick={() => selectTab(tab.id)}
            >
              <span className="tab-icon">{tab.icon}</span>
              <span className="tab-label">{tab.label}</span>
            </button>
          ))}
        </nav>

        <div className="header-right">
          <span className="user-name">{displayName(user?.email)}</span>
          <button className="btn-settings" onClick={() => setShowSettings(true)} title="Settings">⚙️</button>
          <button className="btn-signout" onClick={signOutUser}>Sign out</button>

          {/* Mobile hamburger */}
          <button
            className={`btn-hamburger ${menuOpen ? 'open' : ''}`}
            onClick={() => setMenuOpen(o => !o)}
            aria-label="Menu"
          >
            <span />
            <span />
            <span />
          </button>
        </div>
      </header>

      {/* Mobile dropdown menu */}
      {menuOpen && (
        <div className="mobile-menu">
          {TABS.map(tab => (
            <button
              key={tab.id}
              className={`mobile-menu-item ${activeTab === tab.id ? 'active' : ''}`}
              onClick={() => selectTab(tab.id)}
            >
              <span>{tab.icon}</span>
              <span>{tab.label}</span>
            </button>
          ))}
          <div className="mobile-menu-divider" />
          <button className="mobile-menu-signout" onClick={signOutUser}>Sign out</button>
        </div>
      )}

      {showSettings && <Settings onClose={() => setShowSettings(false)} />}

      <main className="home-main">
        <div className="container">
          {activeTab === 'gallery'  && <PhotoGallery />}
          {activeTab === 'map'      && <ExploreMap />}
          {activeTab === 'timeline' && <TripTimeline />}
          {activeTab === 'blog'     && <Blog />}
          {activeTab === 'health'   && <BmiTracker />}
          {activeTab === 'budget'   && <Budget />}
        </div>
      </main>
    </div>
  );
};

export default Home;
